import { COMPANIES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const companiesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCompanies: build.query({
      query: (params = {}) => ({ url: COMPANIES.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Company', result),
    }),
    getCompanyById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: COMPANIES.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'Company',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createCompany: build.mutation({
      query: (arg) => {
        const isWrapped =
          arg &&
          typeof arg === 'object' &&
          !(arg instanceof FormData) &&
          ('data' in arg || 'params' in arg);
        const payload = isWrapped ? arg.data : arg;
        const params = isWrapped ? arg.params : undefined;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: COMPANIES.LIST,
          method: 'POST',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'Company', id: 'LIST' }],
    }),
    updateCompany: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: COMPANIES.BY_ID(id),
          method: 'PUT',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Company', id },
        { type: 'Company', id: 'LIST' },
      ],
    }),
    deleteCompany: build.mutation({
      query: (id) => ({ url: COMPANIES.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Company', id },
        { type: 'Company', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCompaniesQuery,
  useLazyGetCompaniesQuery,
  useGetCompanyByIdQuery,
  useLazyGetCompanyByIdQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
} = companiesApi;
